module.exports = __webpack_public_path__ + "img/sidebar.afefaa62.jpg";